// stores/breadcrumbs.ts
import { defineStore } from "pinia";
import { arrayRefUpdateId, type TranslationKey } from "~/helpers/common-helpers";

export type PageTitleSegment = {
  id: string;
  position: number;
} & ({ title: MaybeRefOrGetter<Nullable<string>> } | { translationKey: MaybeRefOrGetter<TranslationKey> });

export const usePageTitleStore = defineStore("pageTitle", () => {
  const segments = ref<PageTitleSegment[]>([]);

  const pageTitle = computed(() => {
    if (!segments.value.length) return "Align";

    return segments.value
      .slice()
      .sort((a, b) => a.position - b.position)
      .map((s) => filter.capitalize("translationKey" in s ? t(toValue(s.translationKey)) : toValue(s.title) ?? ""))
      .filter(Boolean)
      .join(" - ");
  });

  const t = useTranslator();
  const filter = useFilter();

  useHead(() => ({ title: pageTitle.value }));

  const addSegment = (segment: PageTitleSegment) => (segments.value = [...segments.value, { ...segment }]);

  const removeSegment = (id: string) => (segments.value = segments.value.filter((s) => s.id !== id));

  const updateSegment = (segment: PageTitleSegment) => arrayRefUpdateId(segments, segment);

  return {
    addSegment,
    removeSegment,
    updateSegment,
  };
});
